import React, { useEffect, useState } from "react";
import AddIcon from "@mui/icons-material/Add";
import { useLocation, useNavigate } from "react-router-dom";
import { AddButton } from "../../utils/commonComponent/Custom/Button";
import { submitSiteDelete } from "./../../utils/commonComponent/delete";
import { fetchQuery } from "./../../utils/commonComponent/fetched";
import ListSearchSection from "../../utils/commonComponent/Custom/ListSearchSection";
import ListView from "../../utils/commonComponent/Custom/listView";
import { DisciplineOptions } from "./disiplineConst";
import { getPermissions } from "../rbac/hasAccess";

const headers = ["id", "DisciplineName", "groupName"];

const fields = [
  { value: "name", label: "Discipline Name" },
  { value: "groupName", label: "Group" },
];

const DisciplineMasterList = (props) => {
  const navigate = useNavigate();
  const location = useLocation();
  const permissions = getPermissions(props.moduleId);
  const handleEdit = (row) => navigate(`/master/editDiscipline/${row.id}`);
  const handleDelete = (row) => submitSiteDelete("discipline", row.id);

  const [disciplineList, setDisciplineList] = useState([]);
  const [totalRows, setTotalRows] = useState(0);
  const [searchBy, setSearchBy] = React.useState(sessionStorage.getItem("searchBy") || "name");
  const [searchKey, setSearchKey] = React.useState(sessionStorage.getItem("searchKey") || "");
  const [searched, setSearched] = React.useState(sessionStorage.getItem("searched") === "true" || false);
   // Pagination
  const [currentPage, setCurrentPage] = useState(() => Number(sessionStorage.getItem("ListPageCount") || 0));
  const [rowsPerPage, setRowsPerPage] = useState(() => Number(sessionStorage.getItem("ListRowsPerPage") || 30));

  const handlePaginationChange = (page, rows) => {
    setCurrentPage(page);
    setRowsPerPage(rows);
    // fetch new data from backend here
  };

  const getWhereClause = () => {
    const colMap = { groupName: "groupName", name: "name" };
    const colName = colMap[searchBy];
    const key = searchKey.trim();

    let whereConditions = ["status = 1"];

    if (colName && key) {
      if (colName === "name") {
        const matches = DisciplineOptions.filter((opt) =>
          opt.label.toLowerCase().includes(key.toLowerCase())
        ).map((opt) => `${colName} = ${opt.id}`);

        if (matches.length) {
          whereConditions.push(`(${matches.join(" OR ")})`);
        }
      } else {
        whereConditions.push(`${colName} LIKE '%${key}%'`);
      }
    }

    return whereConditions.length
      ? `WHERE ${whereConditions.join(" AND ")}`
      : "";
  };

  const getDataQuery = () => {
    const whereClause = getWhereClause();

    let paginationSettings = "";
    if (rowsPerPage !== -1) {
      paginationSettings = `LIMIT ${rowsPerPage} OFFSET ${
        rowsPerPage * Number(currentPage)
      }`;
    }

    return `SELECT * FROM discipline ${whereClause} ORDER BY id DESC ${paginationSettings};`;
  };

  const getCountQuery = () => {
    const whereClause = getWhereClause();

    return `SELECT COUNT(*) AS totalRows FROM discipline ${whereClause};`;
  };

  const fetchData = async () => {
    try {
      const [disciplineData, countResult] = await Promise.all([
        fetchQuery(getDataQuery()),
        fetchQuery(getCountQuery()),
      ]);

      const formattedData = disciplineData.map((item) => ({
        ...item,
        DisciplineName:
          DisciplineOptions.find((key) => key.id == item.name)?.label || "",
      }));

      setDisciplineList(formattedData);
      setTotalRows(countResult?.[0]?.totalRows || 0); // 👈 pagination state
    } catch (error) {
      console.error("Error fetching Discipline data:", error);
    }
  };

  const handleSearch = () => {
    if (!searchBy || !searchKey.trim()) {
      alert("Please select a search field and enter a search value.");
      return;
    }
    fetchData();
    setSearched(true);
    // Save search state to sessionStorage
    sessionStorage.setItem("searchBy", searchBy);
    sessionStorage.setItem("searchKey", searchKey);
    sessionStorage.setItem("searched", "true");
    sessionStorage.setItem("currentPath", location.pathname);
    sessionStorage.setItem("ListPageCount", 0);
    setCurrentPage(0);
  };

  const clearSearch = () => {
    setSearched(false);
    setSearchBy("name");
    setSearchKey("");
     // Clear all employee list session storage
    sessionStorage.removeItem("ListPageCount");
    sessionStorage.removeItem("ListRowsPerPage");
    sessionStorage.removeItem("searchBy");
    sessionStorage.removeItem("searchKey");
    sessionStorage.removeItem("searched");
    setCurrentPage(0);
  };

  useEffect(() => {
    fetchData();
  }, [currentPage, rowsPerPage]);

  useEffect(() => {
    if (searched == false) {
      fetchData();
    }
  }, [searched]);

  return (
    <>
      {(permissions.create || permissions.allAccess) && (
        <AddButton
          id="btn-add-outline"
          to="/master/editDiscipline/0"
          label="Add Discipline"
          icon={<AddIcon fontSize="small" />}
        />
      )}

      <ListSearchSection
        title="Search Discipline"
        fields={fields}
        onSearch={handleSearch}
        searchKey={searchKey}
        setSearchKey={setSearchKey}
        searchBy={searchBy}
        setSearchBy={setSearchBy}
        clearSearch={clearSearch}
        searched={searched}
        setSearched={setSearched}
      />

      <ListView
        headers={headers}
        data={disciplineList}
        actions={{
          edit: handleEdit,
          delete: handleDelete,
        }}
        showCheckbox={true}
        deleteTableName={"discipline"}
        moduleId={props.moduleId}
        currentPage={currentPage}
        rowsPerPage={rowsPerPage}
        totalRows={totalRows}
        onPaginationChange={handlePaginationChange}
      />
    </>
  );
};

export default DisciplineMasterList;
